/* tslint:disable */
/* eslint-disable */

import { ReaderFragment } from "relay-runtime";
import { FragmentRefs } from "relay-runtime";
export type SbSharedRefineMenuMultiSelectSearch_viewer = {
    readonly " $fragmentRefs": FragmentRefs<"SbSharedRefineMenuTypeaheadContainer_viewer">;
    readonly " $refType": "SbSharedRefineMenuMultiSelectSearch_viewer";
};
export type SbSharedRefineMenuMultiSelectSearch_viewer$data = SbSharedRefineMenuMultiSelectSearch_viewer;
export type SbSharedRefineMenuMultiSelectSearch_viewer$key = {
    readonly " $data"?: SbSharedRefineMenuMultiSelectSearch_viewer$data;
    readonly " $fragmentRefs": FragmentRefs<"SbSharedRefineMenuMultiSelectSearch_viewer">;
};



const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "SbSharedRefineMenuMultiSelectSearch_viewer",
  "selections": [
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "SbSharedRefineMenuTypeaheadContainer_viewer"
    }
  ],
  "type": "Viewer",
  "abstractKey": null
};
(node as any).hash = 'a7cbf25c6bfae95a04b020f702c4c3aa';
export default node;
